import React from 'react';
import classNames from 'classnames';
import './svgIcon.scss';

/**
 * Пропы совпадают с теми, что реально передают потребители иконок:
 * `classes.root` (так делает почти весь тулбар), `className`, `viewBox`
 * и остальные атрибуты svg.
 */
export interface SvgIconProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
  classes?: { root?: string };
}

/**
 * Локальная замена утилиты создания иконок из MUI (MYUA-16744, этап 7):
 * прежний импорт вёл в `icons/utils/createSvgIcon` того пакета.
 *
 * Разметка повторяет SvgIcon из MUI v4 один в один. Класс свой —
 * `gen-svg-icon`; базовые размеры и `fill: currentColor` приходили из MUI
 * через JSS, теперь они лежат рядом, в `svgIcon.scss`.
 *
 * Шим остаётся ради тех иконок, которым нет пары в `@myua/icons`: бренды,
 * иллюстрации пустых состояний, индикатор сортировки с покраской половинок,
 * доменные и статусные глифы. Всё остальное живёт на пакете.
 */
export function createSvgIcon(path: React.ReactNode, displayName: string) {
  const Icon = React.forwardRef<SVGSVGElement, SvgIconProps>(function SvgIcon(
    { classes, className, viewBox = '0 0 24 24', ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        className={classNames('gen-svg-icon', classes?.root, className)}
        focusable="false"
        viewBox={viewBox}
        aria-hidden="true"
        role="presentation"
        {...rest}
      >
        {path}
      </svg>
    );
  });
  Icon.displayName = `${displayName}Icon`;
  return Icon;
}

export default createSvgIcon;
